import debug from 'debug';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';

const log = debug('FrontPageCatalogs:Utils:Image');
const breakpoints = new Breakpoints();

class Image {
	/**
	 * @param {string} imageUrl
	 * 
	 * @returns {Object} obj
	 * @returns {number} obj.src
	 * @returns {number} obj.width
	 * @returns {number} obj.height
	 */
	static getCircleImage(imageUrl) {
		let maxWidth = 46;
		let maxHeight = 46;

		if (breakpoints.MediaBreakpointUp('xs')) {
			maxWidth = 57;
			maxHeight = 57;
		}

		const scale = window.devicePixelRatio;

		const circleImage = document.createElement('img');

		circleImage.src = imageUrl + '?w=' + (maxWidth * scale) + '&h=' + (maxHeight * scale);
		circleImage.width = maxWidth;
		circleImage.height = maxHeight;

		return circleImage;
	}

	/**
	 * @returns {Object} obj
	 * @returns {number} obj.maxWidth
	 * @returns {number} obj.maxHeight
	 */
	static getSize() {
		let maxWidth = 79;
		let maxHeight = 108;

		if (breakpoints.MediaBreakpointUp('xs')) {
			maxWidth = 100;
			maxHeight = 137;
		}

		return { maxWidth, maxHeight };
	}

	/**
	 * @param {Object} options
	 * @param {Object} options.imageSize [maxWidth, maxHeight]
	 * @param {string} options.imageUrl
	 * 
	 * @return {string} image url with dimensions
	 */
	static getUrl({ imageUrl, imageSize: { maxWidth, maxHeight } }) {
		const scale = window.devicePixelRatio;
		return imageUrl.replace('{maxwidth}', (maxWidth * scale)).replace('{maxheight}', (maxHeight * scale));
	}

	static verifySize(image) {
		const imageSize = this.getSize();

		const newImage = {};
		newImage.src = image.src;
		newImage.width = imageSize.maxWidth;
		newImage.height = imageSize.maxHeight;

		return newImage;
	}
	
}

export default Image;
